// extracted by mini-css-extract-plugin
module.exports = {"button":"DealsList_button__3ftfE","icon":"DealsList_icon__2Oelo","chatButtonCell":"DealsList_chatButtonCell__4XKCO","collapseIcon":"DealsList_collapseIcon__27cyP"};